import {Stat} from './stat';

export class Report extends Stat {
  label: string | null = '';

  getDate(): Date {
    return this.label ? new Date(this.label) : new Date();
  }

  override toString(): string {
    return this.label ?? '';
  }
}
